module.exports = __webpack_public_path__ + "static/media/emptySearch.6413f453.svg";